import { httpRetry } from '$core/helpers/http-retry';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { StaticStorage } from '../static-storage';
import { Observable, tap } from 'rxjs';
import { ClarificationDataDto } from '../types';

@Injectable({
  providedIn: 'root',
})
export class ClarificationService {
  private readonly http = inject(HttpClient);
  private readonly staticStorage = inject(StaticStorage);

  public getClarificationStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v2/clarification-data').pipe(
      httpRetry(5),
      tap((res: ClarificationDataDto) => {
        this.staticStorage.updateStatic(res);
      })
    );
  }
}
